import "./Card.css";

export function CardHead(props) {
  return (
    <div className="card-head row">
      <div className="card-head-text col">
        {props.eyebrow ? (
          <span className={`card-head-eyebrow t-eyebrow${props.accent ? " t-brand" : ""}`}>
            {props.eyebrow}
          </span>
        ) : null}
        <h2 className="card-head-title t-h3">{props.title}</h2>
        {props.description ? (
          <p className="card-head-desc t-body-sm t-dim">{props.description}</p>
        ) : null}
      </div>
      {props.aside ? <div className="card-head-aside row">{props.aside}</div> : null}
    </div>
  );
}

export default function Card(props) {
  return (
    <section className={`card col${props.className ? ` ${props.className}` : ""}`}>
      {props.children}
    </section>
  );
}
